import noop from 'lodash/noop'
import {
    IndustryType,
} from 'app/enums/label.enums'

import CompanySelector from './CompanySelector'
import useGetCompanyRequests from './hooks/useGetCompanyRequests'

type Props = {
    title?: string,
    value?: string | number,
    filterByIndustryType?: IndustryType[],
    disabled?: boolean,
    onChange?: (value: any, ...params: any[]) => void,
    isRequired?: boolean,
}

const defaultProps: Partial<Props> = {
    title: '',
    value: undefined,
    filterByIndustryType: undefined,
    disabled: false,
    onChange: noop,
    isRequired: false,
}

const CompanySelectorContainer = ({
    title,
    value,
    filterByIndustryType,
    disabled,
    onChange,
    isRequired,
}: Props) => {
    const {
        loadOptions,
    } = useGetCompanyRequests(filterByIndustryType)

    return (
        <CompanySelector
            loadOptions={loadOptions}
            title={title}
            value={value}
            disabled={disabled}
            onChange={onChange}
            isRequired={isRequired}
        />
    )
}

CompanySelectorContainer.defaultProps = defaultProps

export default CompanySelectorContainer
